import React from 'react'
import clear from '../../../assets/icons/clear.svg'
import TableStatus from '../../../components/subComponents/TableStatus/TableStatus'
import Modal from 'syngenta-react-components/dist/components/Modal'

const ModalWithStates = ({ showModal, title, content, loadingPrompt, bottomRow, loading, handleClose, dataTestId }) => {

  const loadingState = (
    <>
      {loadingPrompt && <p className='w100% p0'>{loadingPrompt}</p>}
      <TableStatus status='LOADING'/>
    </>
  )

  return (
    <div data-testid={dataTestId}>
      <Modal
        autoHeight
        show={showModal}
        handleClose={handleClose}
      >
        <div className='w100% h100% bgc-white bd2-s-input bxshmodal bdrs-4'>
          <div className='df jcsb'>
            <p className='fz16 ml16 fw600'>{title}</p>
            <button className='bdnone m0 bgc-t' onClick={handleClose}>
              <img src={clear} alt='cancel button' />
            </button>
          </div>
          <hr className='mt0 mb16 bdnone bt1-s-lightgray' />
          <div className='pl16 pr16 df fxdrr fxww'>
            {loading ? loadingState : content}
          </div>
          <hr className='mt20 mb16 bdnone bt1-s-lightgray' />
          <div className='df jcfe'>
            {bottomRow}
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default ModalWithStates